<template>
  <div class="disputed-orders__filters glass-filters">
    <select v-model="disputeTypeLocal" @change="emitFilterChange" class="filter-select glass-select">
      <option :value="null">All dispute types</option>
      <option value="customer">Customer Dispute</option>
      <option value="credit_card">Credit Card Company</option>
      <option value="snap_finance">Finance</option>
      <option value="merchant_service">Merchant Service</option>
      <option value="attorney">Attorney</option>
      <option value="court">Court</option>
    </select>

    <select v-model="statusLocal" @change="emitFilterChange" class="filter-select glass-select">
      <option :value="null">All status</option>
      <option value="open">Open</option>
      <option value="resolved">Resolved</option>
    </select>

    <select v-model="resolutionLocal" @change="emitFilterChange" class="filter-select glass-select">
      <option :value="null">All resolutions</option>
      <option value="customer_favor">Customer Favor</option>
      <option value="business_favor">Business Favor</option>
    </select>

    <div class="search-wrapper">
      <span class="search-icon">🔍</span>
      <input 
        type="text" 
        v-model="searchLocal" 
        @input="emitFilterChange"
        placeholder="Search by invoice number or customer name..."
        class="filter-search glass-input"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltersBar',
  props: {
    disputeType: { type: String, default: null },
    status: { type: String, default: null },
    resolution: { type: String, default: null },
    search: { type: String, default: '' }
  },
  data() {
    return {
      disputeTypeLocal: this.disputeType,
      statusLocal: this.status,
      resolutionLocal: this.resolution,
      searchLocal: this.search
    }
  },
  watch: {
    disputeType(val) {
      this.disputeTypeLocal = val
    },
    status(val) {
      this.statusLocal = val
    },
    resolution(val) {
      this.resolutionLocal = val
    },
    search(val) {
      this.searchLocal = val
    },
    disputeTypeLocal(val) {
      this.$emit('update:disputeType', val)
    },
    statusLocal(val) {
      this.$emit('update:status', val)
    },
    resolutionLocal(val) {
      this.$emit('update:resolution', val)
    },
    searchLocal(val) {
      this.$emit('update:search', val)
    }
  },
  methods: {
    emitFilterChange() {
      this.$emit('filter-change')
    }
  }
}
</script>

<style scoped>
.disputed-orders__filters {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
}

.filter-select {
  padding: 10px 16px;
  font-size: 14px;
  color: #334155;
  outline: none;
  transition: all 0.2s;
  cursor: pointer;
  min-width: 160px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 10px;
}

.filter-select:hover {
  border-color: rgba(0, 0, 0, 0.1);
}

.filter-select:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
}

.search-wrapper {
  flex: 1;
  position: relative;
  min-width: 250px;
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #94a3b8;
}

.filter-search {
  width: 100%;
  padding: 10px 16px 10px 42px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
  color: #1e293b;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 10px;
}

.filter-search:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/DisputedOrders/components/FiltersBar.vue